import { IModel } from '@/models/IModelBasic';

export const MODELS_PATH = 'models';

export function fullArtifactUrl(model: IModel) {
  const { type, module, key, version } = model;
  return `https://abbevci.visualstudio.com/DS.SmartGatePlatform/_artifacts/feed/device_models/maven/com.enervalis.${type}.${module}%2F${key}/overview/${version}`;
}
